<div class="login_container">
  <main>
    <div class="logo-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-md-auto text-center">
            <div class="logo mb-0"></div>
            <!-- end -->
            <h1 class="h6 text-uppercase fw-bold" style="color: #9a0014">
              Tu Colonial
            </h1>
            <h2>Accede con tus datos</h2>
            <!-- end -->
          </div>
        </div>
      </div>
    </div>
    <!-- logo -->
    <div class="login_content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-9 col-md-7 col-lg-5">
            <div class="card-login">
              <figure class="">
                <img alt="" src="./assets/img/tu-colonial-login.jpeg" />
              </figure>
              <!-- end -->
              <div class="body-login">
                <!-- <ul class="nav nav-pills mb-4" id="pills-tab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button (click)="role = 'client'" [class]="{'active': role == 'client'}" aria-controls="pills-user"
                      aria-selected="true" class="nav-link" data-bs-target="#pills-user" data-bs-toggle="pill"
                      id="pills-user-tab" role="tab" type="button">Clientes</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button (click)="role = 'producer'" [class]="{'active': role == 'producer'}"
                      aria-controls="pills-interme" aria-selected="false" class="nav-link"
                      data-bs-target="#pills-interme" data-bs-toggle="pill" id="pills-interme-tab" role="tab"
                      type="button">Intermediarios</button>
                  </li>
                </ul> -->
                <div class="tab-content" id="pills-tabContent">
                  <div
                    aria-labelledby="pills-user-tab"
                    class="tab-pane fade show active"
                    id="pills-user"
                    role="tabpanel"
                    tabindex="0"
                  >
                    <div class="content">
                      <div class="form-group pt-4">
                        <button
                          (click)="login()"
                          class="mx-auto btn-primary btn btn-border-red bg-btn-red rounded-pill gap-2 fw-bold d-flex justify-content-center align-items-center py-2 px-3 px-md-4 mb-4"
                          style="width: fit-content"
                        >
                          <span class="material-symbols-outlined">key</span>
                          Inicia sesión como {{ roleLabel }}
                        </button>
                      </div>
                    </div>
                    <div class="footer-content">
                      <p class="m-0">
                        ¿Aún no tienes una cuenta de {{ roleLabel }}?
                        <a (click)="register()" href="#">Regístrate</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- login -->
  </main>
  <footer>
    <div class="footer">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-4">
            <div class="title">
              <h2>También disponible en:</h2>
            </div>
          </div>
        </div>
        <div class="row d-flex justify-content-between aling-items-center">
          <div
            class="col-12 col-md-6 mb-4 mb-md-0 d-flex aling-items-center justify-content-center order-md-2"
          >
            <ul class="no_list d-flex aling-items-center appIcons">
              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.lacolonial.lacolonialapp&hl=es_419"
                  target="_blank"
                  ><img alt="" src="/assets/img/googleplay.png"
                /></a>
              </li>
              <li>
                <a
                  href="https://apps.apple.com/do/app/la-colonial/id1483806130"
                  target="_blank"
                  ><img alt="" src="/assets/img/appstore.png"
                /></a>
              </li>
              <li>
                <a
                  href="https://appgallery1.huawei.com/#/app/C102196837"
                  target="_blank"
                  ><img alt="" src="/assets/img/appgallery.png"
                /></a>
              </li>
            </ul>
          </div>
          <div
            class="col-12 col-lg-3 col-md-3 mb-3 mb-md-0 d-flex aling-items-center order-md-1"
          >
            <div class="socialLink">
              <p>Síguenos en las redes</p>
              <ul class="no_list d-flex aling-items-center socialIcons">
                <li>
                  <a
                    href="https://www.facebook.com/lacolonialseguros"
                    target="_blank"
                    ><i aria-hidden="true" class="fab fa-facebook-f"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/lacolonialseg/"
                    target="_blank"
                    ><i aria-hidden="true" class="fab fa-instagram"></i
                  ></a>
                </li>
                <li>
                  <a href="https://twitter.com/LaColonialSeg" target="_blank"
                    ><i aria-hidden="true" class="fab fa-x-twitter"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/la-colonial-s.a.-compa-a-de-seguros"
                    target="_blank"
                    ><i aria-hidden="true" class="fab fa-linkedin-in"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="col-12 col-lg-3 col-md-3 d-flex aling-items-center justify-content-md-end order-md-3"
          >
            <div class="wsLink">
              <p>Escríbenos al WhatsApp</p>
              <a
                href="https://api.whatsapp.com/send?phone=+18095088000&text=%C2%A1Hola!"
                target="_blank"
              >
                <span class="icons">
                  <i aria-hidden="true" class="fab fa-whatsapp"></i>
                </span>
                <span>809.508.8000</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
